
// Add Upsell Items to Cart
document.addEventListener('DOMContentLoaded', () => {
  // Event listener for Add to Cart buttons
  document.querySelectorAll('.button--add-to-order').forEach(function(button) {
    button.addEventListener('click', function(event) {
      let productID = event.target.getAttribute('data-product-id');
      let qty = event.target.closest('div.upsell-item').querySelector('input.quantity__input').value;
      if (!productID) return

      // Prepare form data
      const formData = {
        'items': [{
          'id': productID,
          'quantity': qty
        }]
      };

      // Send the Add to Cart request using Fetch API
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      })
        .then(response => response.json())
        .then(data => {
          // Handle success, update the cart UI or notify the user
          if (data.status === 404) {
            console.error(data.message + ': ' + data.description)
          }
          else if (data['items'][0].id) {
            // Reload the window to display changes.
            window.location.reload();
          }
        })
        .catch((error) => {
          console.error('Error:', error);
        });
    });
  });
})

// Check if Upsells are removed from cart
document.addEventListener('DOMContentLoaded', () => {
  // Event listener for the Cart Remove Button
  document.querySelectorAll('cart-remove-button').forEach((button) => {
    button.addEventListener('click', function(event) {
      event.preventDefault()
    })
  })
})
